import { useRouterState } from '@tanstack/react-router'
import { loadingI18n } from '../../i18n/shared/loading'
import { useLocaleStore } from '../../store/locale'
import { PexifyLoader } from './PexifyLoader'
import { useLoadingVisibility } from './useLoadingVisibility'

import './RouteLoadingOverlay.css'

export const ROUTE_LOADING_DELAY_MS = 600
export const ROUTE_LOADING_MINIMUM_MS = 400
export const ROUTE_LOADING_EXIT_MS = 100

export function RouteLoadingOverlay() {
  const isLoading = useRouterState({
    select: (state) => state.isLoading,
  })
  const phase = useLoadingVisibility(isLoading, {
    delayMs: ROUTE_LOADING_DELAY_MS,
    minimumVisibleMs: ROUTE_LOADING_MINIMUM_MS,
    exitMs: ROUTE_LOADING_EXIT_MS,
  })
  const locale = useLocaleStore((state) => state.locale)
  const status = phase === 'hidden' ? '' : loadingI18n[locale].status

  return (
    <>
      <span
        aria-atomic="true"
        aria-live="polite"
        className="sr-only"
        role="status"
      >
        {status}
      </span>
      {phase === 'hidden' ? null : (
        <div
          className="route-loading-overlay"
          data-phase={phase}
          data-route-loading-overlay
        >
          <PexifyLoader decorative mode="navigation" />
        </div>
      )}
    </>
  )
}
